import React from 'react'
import { useIntl } from 'react-intl'

import styles from './styles.module.css'
import IconInfo from 'client/icons/Info'
import CopyText from 'client/components/CopyText'
import ButtonLink from 'src/comps/Atom/Buttons/ButtonLink'

interface BookingCodesProps {
  voucherNumbers: string[]
  purchaseId: string
  onClick: (type: string) => void
}

const VoucherBookingCodes = ({ voucherNumbers, purchaseId, onClick }: BookingCodesProps) => {
  const intl = useIntl()

  const getVoucherNumberLabel = (index: number): string => {
    const label = intl.formatMessage({
      id: 'voucher.number',
    })
    const suffix = voucherNumbers.length > 1 ? ` ${index + 1}` : ''
    return `${label}${suffix}`
  }

  const getVoucherNumber = (voucherNumber: string): string =>
    voucherNumber === ''
      ? intl.formatMessage({
          id: 'global.pending',
        })
      : voucherNumber

  return (
    <aside className={styles.container}>
      <div className={styles.codes}>
        {voucherNumbers.map((voucherNumber, index) => (
          <div key={voucherNumber}>
            {getVoucherNumberLabel(index)}:{' '}
            {voucherNumber ? (
              <CopyText>{getVoucherNumber(voucherNumber)}</CopyText>
            ) : (
              getVoucherNumber(voucherNumber)
            )}
          </div>
        ))}
        <div>
          {intl.formatMessage({
            id: 'global.pin_code',
          })}
          : <CopyText>{purchaseId}</CopyText>
        </div>
      </div>
      <div className={styles.linkContainer}>
        <div className={styles.link}>
          <IconInfo className={styles.icon} />
          <ButtonLink
            onClick={() => onClick('codes')}
            text="global.use-reservation-codes"
            hasChevron
          />
        </div>
      </div>
    </aside>
  )
}

export default VoucherBookingCodes
